import Chip from '@/components/Chip/Chip';

export { type ChipProps } from './Chip';

export default Chip;
